import React, { createContext } from "react";

//Excell Format
import * as XLSX from "xlsx";

// Context
export const ExcelContext = createContext();

const ExcelContextProvider = (props) => {
  //Excel File Reader
  const readExcel = (file, state, Alert, fileHeader) => {
    const reader = new FileReader();
    reader.onload = (evt) => {
      /* Parse data */
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
      /* Update state */
      var obj = convertToJson(data, Alert, fileHeader);
      state(obj);
    };
    reader.readAsBinaryString(file);
  };

  //Excel to JSON converter
  const convertToJson = (csv, Alert, fileHeader) => {
    var lines = csv.split("\n");
    var header = lines[0].split(",");
    var is_same =
      fileHeader.length === header.length &&
      fileHeader.every((element, index) => {
        return element === header[index];
      });

    if (is_same) {
      const result = [];
      for (var i = 1; i < lines.length - 1; i++) {
        var obj = {};
        var currentline = lines[i].split(",");
        for (var j = 0; j < header.length; j++) {
          obj[header[j]] = currentline[j];
        }
        result.push(obj);
      }
      return result;
    } else {
      Alert(
        "Wrong File! Please download given Excel file and upload your data accordingly in it.",
      );
      return [];
    }
  };

  const exportToExcel = (file, name) => {
    const fileName = name ? name : "data";

    const wb = XLSX.utils.book_new();
    const wsAll = XLSX.utils.aoa_to_sheet(file);
    XLSX.utils.book_append_sheet(wb, wsAll, "All Data");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  return (
    <ExcelContext.Provider value={{ readExcel, exportToExcel }}>
      {props.children}
    </ExcelContext.Provider>
  );
};

export default ExcelContextProvider;
